var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.75 6.97h-.875m.875 0 .75-.794m-.75.795-.875.926m.875-.926v-.795m-.875.795h-.92m.92 0v.926m0-.926v-.795m-.92.795h-.83m.83 0v.926m0-.926v-.795m-.83.795h-.875m.875 0v.926m0-.926v-.795m-.875.795-.75-.795m.75.795.875.926m-.875-.926v-.795m-.75 0-1-1.058h1m0 1.058h.75m-.75 0V5.118m5 1.058 1-1.058h-1m0 1.058h-.75m.75 0V5.118m-4.25 1.058h.875m-.875 0V5.118m.875 1.058h.83m-.83 0V5.118m.83 1.058h.92m-.92 0V5.118m.92 1.058h.875m-.875 0V5.118m.875 1.058V5.118m-.875 2.78L12 8.823l-.044-.048m.919-.879h-.92m-.83 0h.83m-.83 0 .83.88m0-.88v.88m0-3.66h.92m-.92 0h-.83m1.75 0h.875m0 0h.75m-3.375 0h-.875m0 0H9.5M14.987 21H9.013c-3.466 0-3.733-3.042-1.862-4.698l2.353-2.088a2.96 2.96 0 0 0 0-4.428L7.151 7.698C5.28 6.042 5.547 3 9.013 3h5.974c3.466 0 3.733 3.042 1.862 4.698l-2.354 2.088a2.96 2.96 0 0 0 0 4.428l2.354 2.088C18.72 17.958 18.453 21 14.987 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.0c87c761ef3cb0aee85ae0e7b4bd718c.svg";
export { ForwardRef as ReactComponent };